import React from 'react';
import FBCommentGuardSlideoutBannerNormalSrc from './FBCommentGuardSlideoutBanner_normal.png';
import FBCommentGuardSlideoutBannerWhiteSrc from './FBCommentGuardSlideoutBanner_white.png';

export const FBCommentGuardSlideoutBanner = ({
  textColor,
}: {
  textColor: 'white' | 'normal';
}) => {
  return textColor === 'white' ? (
    <img src={FBCommentGuardSlideoutBannerWhiteSrc} />
  ) : (
    <img src={FBCommentGuardSlideoutBannerNormalSrc} />
  );
};
